import { ServiceResult } from './ServiceResult';


export class TServiceResult<T> extends ServiceResult{
    constructor(success: boolean, response: string, retVal: T) {
        super(success, response)
        this.returnValue = retVal;
    }
    returnValue : T;
}